import api from "../Utils/axios";
import { filterParams } from "../Utils/helpers";

export const CHAT_PAGE_SIZE = 30;

export const getConversations = (role, status) => {
  return api.get(`/admin-chat/conversations`, {
    params: filterParams({
      role,
      status,
      limit: 100,
    }),
  });
};

/** Newest first; pass `before` (oldest loaded message id) to get older messages. */
export const getConversationMessages = (participantId, before) => {
  return api.get(`/admin-chat/messages/${participantId}`, {
    params: filterParams({ limit: CHAT_PAGE_SIZE, before }),
  });
};

export const getChatSession = (participantId) => {
  return api.get(`/admin-chat/status`, { params: { receiverId: participantId } });
};

export const sendMessage = (data) => {
  return api.post("/admin-chat/sendMessage", data);
};

export const acceptChat = (receiverId) => {
  return api.post("/admin-chat/accept", { receiverId });
};

export const declineChat = (receiverId, reason) => {
  return api.post("/admin-chat/decline", { receiverId, reason });
};

export const closeChat = (receiverId) => {
  return api.post("/admin-chat/close", { receiverId });
};

export const markChatRead = (receiverId) => {
  return api.post("/admin-chat/read", { receiverId });
};

export const getUnreadChatCount = () => {
  return api.get("/admin-chat/unreadCount");
};
